import React, { useEffect, useMemo, useRef, useState } from 'react';
import NotificationAlert from "react-notification-alert";
import DataTable from 'components/Core/DataTable';
import Utils from '../../lib/Utils/Utils';
import FromValidator from 'lib/Utils/FormValidator';
import Purchaser from '../../lib/Core/Backend/Controllers/Purchaser';
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label } from 'reactstrap';
import BaseModal from 'components/Core/BaseModal';
import ContactsCtl from './ContactsCtl';
import Notify from 'lib/Utils/Alert';
import Auth from 'lib/Core/Backend/Controllers/Auth';
import Select from 'react-select';
import RepresentativeUser from 'lib/Core/Backend/Controllers/RepresentativeUsers';
import Spinner from 'react-bootstrap/Spinner';

const purchaserGroups = ['PURCHASER', 'PURCHASER_REPRESENTATIVE', 'PURCHASER_USER_MANAGER', 'PURCHASER_API_CLIENT']

const PurchaserManager = (props) => {
  const { token } = props;
  const purchaserCtl = useMemo(() => new Purchaser(token), [token]);
  const representativeUsersClt = useMemo(() => new RepresentativeUser(token), [token]);
  const authCtl = useMemo(() => new Auth(token), [token]);

  const [modal, setModal] = useState(false);
  const toggle = () => { setModal(!modal) };
  const [contactModal, setContactModal] = useState(false);
  const [purchaserContacts, setPurchaserContacts] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [contactsLoading, setContactsLoading] = useState(true);
  const [warningModal,setWarningModal] = useState(false)
  const toggleWarning = () => setWarningModal(!warningModal);
  const [loaderPurchaser, setLoaderPurchaser] = useState(false);
  const [loaderSaveContact, setLoaderSaveContact] = useState(false);
  const purchaserUserForm = useRef();
  const contactForm = useRef();
  const table = useRef();
  const contactSelect = useRef();

  const alert = useRef();
  const contactAlert = useRef();
  const loadPurchaserFunc=()=>{
    setTimeout(()=>{
      setLoaderPurchaser(false)
    },1500)
  }
  const addContact = () => {
    setLoaderPurchaser(true)
    if (!contactForm.current) {
      loadPurchaserFunc();
      return};
    const cv = new FromValidator(contactForm.current, (type, message) => Notify(contactAlert, type, message),
      [
        { label: "Contact Type", property: "purchaserContactTypeId", input: "contactTypeId", required: true, noVal: "-1" },
        { label: "First Name", property: "contactFirstName", input: "contactFirstName", required: true },
        { label: "Last Name", property: "contactLastName", input: "contactLastName", required: true },
        { label: "Phone", property: "phone", input: "contactPhone", required: true, type: "phone" },
        { label: "Mobile", property: "mobile", input: "contactMobile", required: false, type: "phone" },
        { label: "Email", property: "email", input: "contactEmail", required: true, type: "email" }
      ]
    );

    if (!cv.isFormValid())
      {
        loadPurchaserFunc();
        return
      };

    const newContact = cv.getDTO();
    newContact.purchaserId = props.purchaser.id;

    authCtl.checkIfUserExists(cv.getDTO().email, (data) => {
      if (!!data) {
        if (data.valueOf()) {

          Notify(contactAlert, 'danger', "Email already in use");
          loadPurchaserFunc();
        } else {
          purchaserCtl.addContact(props.purchaser.id, newContact, (data) => {
            if(data?.status === 403){
              toggleWarning();
              loadPurchaserFunc();
              return;
            }
            if (data && !data.error) {
              setContactModal(false);
              setContactsLoading(true);
              Notify(alert, "info", "Contact saved successfully");
              loadPurchaserFunc();
              data.value = data.id;
              data.label = `${data.contactFirstName} ${data.contactLastName}`;
              setContacts([...contacts, data]);
              setContactsLoading(false);
            } else {
              Notify(contactAlert, 'danger', data.errorMessage);
              loadPurchaserFunc();
            }
          });
        }
      }
    });
  }

  const loadContactFunc=()=>{
    setTimeout(()=>{
      setLoaderSaveContact(false)
    },1500)
  }

  const addUser = () => {
    setLoaderSaveContact(true)
    if (!contactSelect.current){
      loadContactFunc();
      return};

    if (contactSelect.current.getValue().length !== 0) {
      if (!purchaserContacts.length > 0) {
        Notify(alert, 'danger', 'This purchaser has no contacts');
        loadContactFunc();
        return
      }

      const contact = purchaserContacts.find(contact => contact.id === contactSelect.current.getValue()[0].id);
      const user = {
        firstName: contact.contactFirstName,
        lastName: contact.contactLastName,
        username: contact.email,
        phoneNumber: `${contact.phone}`,
      };

      purchaserCtl.addPurchaserUser(props.purchaser.id, contact.id, user, (data) => {
        if(data?.status === 403){
          loadContactFunc();
          toggleWarning();
          toggle()
          
        }
        if (data && !data.error) {
          representativeUsersClt.addUserToGroups(data.id, purchaserGroups, groupsData => {
            if (groupsData.error || groupsData.errorMessage) {
              Notify(alert, 'danger', groupsData.errorMessage ?? groupsData.error);
              loadContactFunc();
            } else {
              Notify(alert, 'success', 'Succesfully created User');
              loadContactFunc();
              toggle();
            }
          });
        } else {
          Notify(alert, 'danger', data.errorMessage ?? data.error);
          loadContactFunc();
        }
      });
    } else {
      Notify(alert, 'danger', 'Select a contact');
      loadContactFunc();
      return;
    }
  }

  const prepareContactForm = () => {
    Utils.FillDropdown(contactForm.current.contactTypeId, props.contactTypes);
  }

  const prepareNewUserModal = () => {
    let availableContacts = [];
    purchaserContacts.forEach((contact, idx) => {
      authCtl.checkIfUserExists(contact.email, (data) => {
        if (data) {
          if (!data.valueOf()) {
            contact.value = contact.id;
            contact.label = `${contact.contactFirstName} ${contact.contactLastName}`
            availableContacts.push(contact);
          }
          if (purchaserContacts.length - 1 === idx) {
            setContacts(availableContacts);
            setContactsLoading(false);
          }
        }
      });
    });
  };

  useEffect(() => {
    purchaserCtl.users(props.purchaser.id, (data) => {
      if (data && !data.error) {
        if (table.current) {
          table.current.dataTable.clear().rows.add(data).draw();
        }
      } else {
        if (table.current) {
          table.current.dataTable.clear().rows.add([]).draw();
        }
        Notify(alert, 'danger', data.errorMessage || data.error);
      }
    });
  }, [modal, props.purchaser.id, purchaserCtl]);

  useEffect(() => {
    purchaserCtl.contacts(props.purchaser.id, (data) => {
      if (data && !data.error) {
        setPurchaserContacts(data);
      } else {
        Notify(alert, 'danger', data.errorMessage || data.error);
      }

    });

  }, [props.purchaser.id, purchaserCtl]);

  return (
    <div>
      <NotificationAlert ref={alert} />
      <div className='table-responsive'>
      <DataTable
        ref={table}
        data={null}
        columns={[
          {
            title: "Name", data: "firstName", render: (data, type, row) => {
              if (data) {
                return `${row.firstName} ${row.lastName}`
              }
            }
          },
          { title: "Email", data: "username" },
          { title: "Phone", data: "phoneNumber" },

        ]}

        resendEmail={{
          callback: (row) => {
            const body = {};
            purchaserCtl.resendTemperaryCredentials(
              props.purchaser.id,
              row.data().contactId,
              row.data().firstName,
              row.data().lastName,
              row.data().username,
              row.data().phoneNumber,
              (data) => {
                if(data?.status === 403){
                  toggleWarning();
                  return;
                }
                if (data && !data.error) {
                  Notify(alert, 'success', "Temporary Credentials sent to the user mail id.");
                } else {
                  Notify(alert, 'danger', "User already activated.");
                }
              }
            );
          },
          viewMode: false,
        }}

        addRemoveButton={{
          callback: (row) => {
            purchaserCtl.disableUser(props.purchaser.id, row.data().contactId, (data) => {
              if(data?.status === 403){
                toggleWarning();
              }
              if (data && !data.error) {
                purchaserCtl.users(props.purchaser.id, (data) => {
                  if (data && !data.error) {

                    if (table.current) {
                      table.current.dataTable.clear().rows.add(data).draw();
                    }
                  } else {
                    Notify(alert, 'danger', data.error);
                  }
                });
              } else {
                if(data?.error === "Server error response code: 403. Unable to parse response body."){

								}else{
									Notify(alert, "danger", data.errorMessage ?? data.error);
								}
              }
            });
          }, viewMode: false
        }}
        options={{ dom: "tr" }}
      />
      </div>
      <Row form className='justify-content-center'>
        <Col md="10" className="justify-content-end text-right">
          <Button type="button" className="btn btn-primaryTwo" onClick={toggle}>Add new User</Button>
        </Col>
      </Row>

      <Modal isOpen={modal} toggle={toggle} onOpened={prepareNewUserModal} backdrop="static" centered={true} size="md" style={{ maxWidth: "80% !important" }} >
        <ModalHeader toggle={toggle} className="custom_header_colourTwo">Create new User</ModalHeader>
        <ModalBody>
          <NotificationAlert  ref={alert}/>
          <Form className="mt-4" innerRef={purchaserUserForm}>

            <Row className="justify-content-center text-center">
              <Col md={'auto'}>
                <FormGroup>
                  <Label for="purchaserUserSelect" className="text-center">Select an existing contact</Label>
                  <Select id="purchaserUserSelect" ref={contactSelect} placeholder="Select a contact..." options={contacts} isLoading={contactsLoading} isClearable={true} />
                </FormGroup>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col md={3}>
                <hr />
              </Col>
              <Col md={1} className="px-0">
                <h6 className="text-center mt-2 text-secondary"> or </h6>
              </Col>
              <Col md={3}>
                <hr />
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col md={'auto'}>
                <Button type="button" className="px-2 py-2 mx-2 btn btn-primaryTwo" onClick={() => { setContactModal(true); }}>Create new contact</Button>
              </Col>
            </Row>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="secondary" onClick={toggle}>Cancel</Button>{' '}
          <Button type="button" className="btn btn-primaryTwo" onClick={addUser} disabled={loaderSaveContact}>{!loaderSaveContact && "save"} {loaderSaveContact && <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
        style={{
          margin: "0px 8px"
        }}
      />}</Button>
        </ModalFooter>
      </Modal>

      <BaseModal okButtonTag="Add Contact" cancelButtonTag="Close" onOk={addContact}
        onCancel={() => setContactModal(false)} trigger={contactModal}
        toggle={() => setContactModal(!contactModal)}
        onOpened={prepareContactForm}
        size="lg"
        title="Add Purchaser Contacts"
        buttonLoader={loaderPurchaser}
      >
        <NotificationAlert ref={contactAlert} />
        <ContactsCtl formRef={contactForm} />
      </BaseModal>
      <Modal isOpen={warningModal} toggle={toggleWarning} backdrop="static">
            <ModalHeader className="bg-warning" toggle={toggleWarning}>Access Denied</ModalHeader>
            <ModalBody>
                <p className="card-just-text">
				You do not have access to perform this action
                </p>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggleWarning}>Close</Button>
            </ModalFooter>
        </Modal>


    </div>
  );
}

export default PurchaserManager;